import BaseSitelink from '@bingads-webui-campaign-legacy/adextension-sitelink/view/base-sitelink';
import PageContext from '@bingads-webui-static-legacy/page-context';

const schema = window.globalLegacySchema.get('Sitelink2AdExtension');

const { IsSitelinkExtensionDestinationURLDisabled } = (PageContext && PageContext.Permissions) || {};

export default class SitelinkAdExtensionEditor2 extends BaseSitelink {
  initialize({
    extension,
    data,
    campaignId,
    adgroupId,
    isForVNext,
  } = {}) {
    super.initialize({
      extension,
      schema,
      campaignId,
      adgroupId,
      data,
      entityType: 'Sitelink2AdExtension',
      placeholderEnabled: false,
      destinationURLDisabled: IsSitelinkExtensionDestinationURLDisabled || false,
      isForVNext,
    });
  }

  currentModel() {
    const sitelink2 = super.currentModel();

    if (this.upgradedUrlView) {
      // handle the inconsistancy of UpgradedUrl schema.
      sitelink2.FinalMobileUrls = sitelink2.MobileFinalUrls;
      delete sitelink2.MobileFinalUrls;
    }

    return sitelink2;
  }
}
